import { render, staticRenderFns } from "./TJdocMarkdownCallback.vue?vue&type=template&id=17223f5b&scoped=true"
import script from "./TJdocMarkdownCallback.vue?vue&type=script&lang=js"
export * from "./TJdocMarkdownCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17223f5b",
  null
  
)

export default component.exports